import { createApi } from "@reduxjs/toolkit/query/react";
import { components } from "../../types/api";
import { components as processorComponents } from "../../types/api.processor";
import { baseQueryWithReauth } from "../../utils/baseQuery";

type AmazonRegion = components["schemas"]["AmazonRegion"];
type GetProfilesResponse =
  components["schemas"]["ApiResponse_AmazonDspProfilesRespose_"];
type GetAdvertisersResponse =
  components["schemas"]["ApiResponse_AmazonDspAdvertisersRespose_"];

type ProcessAmazonReportsResult =
  processorComponents["schemas"]["ProcessAmazonReportsResult"];

const processorBaseUrl =
  process.env.REACT_APP_PROCESSOR_URL || "http://localhost:8081";

type GetProfilesParams = {
  region?: AmazonRegion;
};

type GetAdvertisersParams = {
  region?: AmazonRegion;
  scope?: string;
};

export const amazonApi = createApi({
  reducerPath: "amazonApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["AmazonDspProfiles", "AmazonDspAdvertisers"],
  endpoints: (builder) => ({
    getProfiles: builder.query<GetProfilesResponse, GetProfilesParams | void>({
      query: (params) => {
        const searchParams = new URLSearchParams();
        if (params?.region) {
          searchParams.append("region", params.region);
        }
        const queryString = searchParams.toString();
        return queryString
          ? `/amazon-dsp/profiles?${queryString}`
          : "/amazon-dsp/profiles";
      },
      providesTags: ["AmazonDspProfiles"],
    }),
    getAdvertisers: builder.query<
      GetAdvertisersResponse,
      GetAdvertisersParams | void
    >({
      query: (params) => {
        const searchParams = new URLSearchParams();
        if (params?.region) {
          searchParams.append("region", params.region);
        }
        if (params?.scope) {
          searchParams.append("scope", params.scope);
        }
        const queryString = searchParams.toString();
        return queryString
          ? `/amazon-dsp/advertisers?${queryString}`
          : "/amazon-dsp/advertisers";
      },
      providesTags: ["AmazonDspAdvertisers"],
    }),
    processAmazonReports: builder.mutation<ProcessAmazonReportsResult, void>({
      query: () => ({
        url: `${processorBaseUrl}/metrics/process-amazon-reports`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetProfilesQuery,
  useLazyGetProfilesQuery,
  useGetAdvertisersQuery,
  useLazyGetAdvertisersQuery,
  useProcessAmazonReportsMutation,
} = amazonApi;
